import { render, staticRenderFns } from "./DodatniSadrzajBase.vue?vue&type=template&id=6a085786&scoped=true&"
import script from "./DodatniSadrzajBase.vue?vue&type=script&lang=js&"
export * from "./DodatniSadrzajBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a085786",
  null
  
)

export default component.exports